import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import StatusIndicator from './StatusIndicator';
import { logger } from '../utils/logger';

function TermsPolicy() {
  const [termsData, setTermsData] = useState(null);
  const [policyData, setPolicyData] = useState(null);
  const [loadError, setLoadError] = useState(false);
  // Дата читается из поля lastModified в JSON
  const [lastModifiedTerms, setLastModifiedTerms] = useState(null);
  const [lastModifiedPolicy, setLastModifiedPolicy] = useState(null);
  const { hash } = useLocation();

  useEffect(() => {
    const loadJson = async (url, setData, setLastModified) => {
      try {
        const response = await fetch(url, { cache: 'no-cache' });
        if (response.ok) {
          const data = await response.json();
          setData(data);
          // Читаем дату из поля lastModified в JSON
          if (data.lastModified) {
            const parsed = new Date(data.lastModified);
            if (!isNaN(parsed.getTime())) {
              setLastModified(parsed);
            }
          }
        } else {
          setLoadError(true);
          logger.error(`Не удалось загрузить данные ${url}`);
        }
      } catch (error) {
        setLoadError(true);
        logger.error(`Ошибка при загрузке ${url}:`, error);
      }
    };

    loadJson('/data/terms.json', setTermsData, setLastModifiedTerms);
    loadJson('/data/policy.json', setPolicyData, setLastModifiedPolicy);
  }, []);

  if (loadError) {
    return (
      <main className="terms-main">
        <section className="terms-center page-pad">
          <StatusIndicator variant="error" className="terms-loading" />
        </section>
      </main>
    );
  }

  // Прокрутка к якорю с учётом фиксированной шапки
  useEffect(() => {
    if (!termsData || !policyData) return;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        // Native scroll with CSS scroll-padding-top handled in index.css
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [termsData, policyData, hash]);

  const formatDate = (date) => {
    if (!date) return '';
    return date.toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  if (!termsData || !policyData) {
    return (
      <main className="terms-main">
        <section className="terms-center page-pad">
          <div className="terms-section">
            <StatusIndicator variant="loading" className="terms-loading" />
          </div>
        </section>
      </main>
    );
  }

  const renderBlockList = (data) => (
    <>
      <h2>{data.title}</h2>
      {data.blocks.map((block, index) => (
        <div key={index} className="terms-block">
          <h3>{block.title}</h3>
          <ul>
            {block.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );

  return (
    <main className="terms-main">
      <section className="terms-center page-pad">
        <div className="terms-section" id="terms">
          {renderBlockList(termsData)}
          {lastModifiedTerms && (
            <div className="terms-last-updated">Последнее обновление: {formatDate(lastModifiedTerms)}</div>
          )}
        </div>
        <div className="terms-section" id="policy">
          {renderBlockList(policyData)}
          {lastModifiedPolicy && (
            <div className="terms-last-updated">Последнее обновление: {formatDate(lastModifiedPolicy)}</div>
          )}
        </div>
      </section>
    </main>
  );
}

export default TermsPolicy;
